import { useEffect, useState } from "react";
import { loadMarkdown } from "../utils/loadMarkdown";

/**
 * Fetch a bundled markdown asset (imported as a URL) as text. The async fetch +
 * state live in this hook so consumers stay effect-free business components
 * (same pattern as the other domain hooks). Returns null while loading.
 */
export function useMarkdown(url: string): { content: string | null } {
  const [content, setContent] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setContent(null);
    void loadMarkdown(url)
      .then((text) => {
        if (!cancelled) setContent(text);
      })
      .catch((error: unknown) => {
        console.error("Failed to load markdown", url, error);
      });
    return () => {
      cancelled = true;
    };
  }, [url]);

  return { content };
}
